<template>
  <div id="notice-detail">
    <span id="noti-title">{{ title }}</span>
    <br>
    <span id="noti-date">{{ dateText }}</span>
    <hr id="detail-divider">
    <p id="noti-content" v-html="message"></p>
    <comp-loading
      v-if="isLoading"
    ></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import RESPONSE from '@/constants/response';
import CompLoading from '@/components/CompLoading';

export default {
  name: 'notice-detail',
  mixins: [
    common,
  ],
  components: {
    RESPONSE,
    CompLoading,
  },
  data() {
    return {
      title: '',
      dateText: '',
      message: '',

      isLoading: false,
    };
  },
  methods: {
    getNoticeItem(bbsId) {
      this.isLoading = true;

      const params = {
        bbsId,
      };
      this.$store.dispatch('getNoticeItem', params)
        .then((data, status) => {
          if (status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.getNoticeItem(bbsId);
              } else {
                this.invalidateLogin();
              }
            });
          } else {
            this.displayNotice(data.data);
          }
          this.isLoading = false;
        });
    },
    displayNotice(notice) {
      this.title = notice.title;
      this.dateText = this.getDateText(notice.regDate);
      this.message = notice.contents;
    },
    getDateText(dateTime) {
      const noticeDate = new Date(dateTime);

      const year = noticeDate.getFullYear();
      let month = (noticeDate.getMonth() + 1).toString();
      let day = (noticeDate.getDate()).toString();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
  },
  created() {
    this.getNoticeItem(this.$route.params.item);
  },
};
</script>

<style lang="scss" src="../../scss/notice-detail.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/notice/notice-detail.vue